import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import * as angular from 'angular';
import {InsuranceEditComponent} from "./insurance-edit.component";

/*
* Workaround para que siga funcionando la configuración
* $routeProvider.otherwise() que redirige a la pantalla de error
* cuando se ingresan URLs desconocidas.
* */
angular.module('CarsSaraBo')
    .config(['$routeProvider', ($routeProvider) => {
        $routeProvider
            .when('/company/:companyId/insurances/add', {template: ''})
            .when('/company/:companyId/insurances/:id', {template: ''});
    }]);
/***/

const additionalRoutes: Routes = [
    {path: 'company/:companyId/insurances/add', component: InsuranceEditComponent},
    {path: 'cars-sara-v2/web/company/:companyId/insurances/add', component: InsuranceEditComponent},
    {path: 'company/:companyId/insurances/:id', component: InsuranceEditComponent},
    {path: 'cars-sara-v2/web/company/:companyId/insurances/:id', component: InsuranceEditComponent}
];

@NgModule({
    imports: [
        RouterModule.forChild(additionalRoutes)
    ],
    exports: [
        RouterModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class InsuranceRoutingModule {
}


// WEBPACK FOOTER //
// ./public/upgrade/feature/insurance/insurance-routing.module.ts